const mentorship = [
	{
		path: '/mentorship-recruitment-status/list',
		name: 'jobs-mentorship-recruitment-status-list',
		component: () =>
			import(/* webpackChunkName: "mentorship" */ '@/views/jobs/mentorship-recruitment-status/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGJ,employment',
		},
	},
]

export default mentorship
